<template>
  <div class="user">
    <div class="photo">
      <img :src="userAvatar" alt="avatar"/>
    </div>
    <div class="info">
      <span>{{ user.name }}</span>
    </div>
  </div>
</template>
<script>
  import CollapseTransition from 'element-ui/lib/transitions/collapse-transition'

  export default {
    components: {
      [CollapseTransition.name]: CollapseTransition
    },
    data () {
      return {
        isClosed: true,
        user: JSON.parse(localStorage.getItem('user')),
        userAvatar: 'static/img/faces/' + JSON.parse(localStorage.getItem('user')).avatar
      }
    },
    methods: {
      toggleMenu () {
        this.isClosed = !this.isClosed
      }
    }
  }
</script>
<style>
  .collapsed {
    transition: opacity 1s;
  }
</style>
